import { render } from "./component-egrul-kod-ogrn.vue?vue&type=template&id=ddd4940a"
import script from "./component-egrul-kod-ogrn.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-kod-ogrn.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-kod-ogrn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddd4940a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddd4940a', __exports__)) {
    api.reload('ddd4940a', __exports__)
  }
  
  module.hot.accept("./component-egrul-kod-ogrn.vue?vue&type=template&id=ddd4940a", () => {
    api.rerender('ddd4940a', render)
  })

}


export default __exports__